import React from 'react';
import { styled } from '@glitz/react';
import { Paragraph, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';

type PropType = {
  openingHours: {
    [item: string]: string;
  };
};

const Table = styled.table({
  width: '100%', padding: { xy: 0 }, borderSpacing: 0, borderCollapse: 'collapse'
})

const Tr = styled.tr({
  padding: { y: '2px' }
})

const Td = styled.td({
  width: '100%'
})

function OpeningHours({ openingHours }: PropType) {
  return (
    <Table>
      <styled.Tbody>
        {Object.entries(openingHours).map((openingHour, index) => {
          const [days, hours] = openingHour;
          return (
            <Tr key={index}>
              <Td>
                <Paragraph fontSize={ResponsiveSize.D14_M14_L130}>{days}</Paragraph>
              </Td>
              <Td>
                <Paragraph fontSize={ResponsiveSize.D14_M14_L130} css={{ whiteSpace: 'nowrap' }}>
                  {hours}
                </Paragraph>
              </Td>
            </Tr>
          );
        })}
      </styled.Tbody>
    </Table>
  );
}

export default OpeningHours;
